module.exports = __webpack_public_path__ + "static/media/img-02.9cb5b4fa.jpg";